import { ADD_ACTION_TENDENCY } from "./types";

const addActionTendency = (code) => async (dispatch) => {
    dispatch({ type: ADD_ACTION_TENDENCY, code });
};

export default addActionTendency;
